export default "__VITE_ASSET__DEK4IMPU__"